module.exports = __webpack_public_path__ + "img/hago.a4ac0c0.jpg";